// 用户中心模块
import { UserInfo, UserClassroomItem } from '@/interface'
import {
  ICourseListItem
} from '@/interface/course'

interface ClassroomModel {
  total: number
  rows: UserClassroomItem[]
}
export interface ProcessingCourseInfo {
  classroomList: UserClassroomItem[]
  userCourseList: ICourseListItem[]
}

const state = {
  userInfo: {} as UserInfo,
  classroomList: {} as ClassroomModel,
  certificateList: [] as any[],
  credits: [] as any[],
  certificationList: [] as any[],
  learningProgress: [] as any[],
  processingCourseInfo: {
    classroomList: [] as UserClassroomItem[],
    userCourseList: [] as ICourseListItem[]
  } as ProcessingCourseInfo
}

export type UserState = typeof state

const userStore = {
  namespaced: true,
  state,
  mutations: {
    setUserInfo (state: UserState, userInfo: UserInfo): void {
      state.userInfo = userInfo
    },
    setClassroom (state: UserState, classroomList: ClassroomModel): void {
      state.classroomList = classroomList
    },
    setCertificateList (state: UserState, certificateList: any[]): void {
      state.certificateList = certificateList
    },
    setCredits (state: UserState, credits: any[]): void {
      state.credits = credits
    },
    setCertificationList (state: UserState, certificationList: any[]): void {
      state.certificationList = certificationList
    },
    setLearningProgress (state: UserState, learningProgress: any[]): void {
      state.learningProgress = learningProgress
    },
    setProcessingCourseInfo (state: UserState, info: ProcessingCourseInfo): void {
      state.processingCourseInfo = info
    }
  }
}

export {
  userStore
}
